import { LangKey } from "@vixi/localization";
import { emptyLesson, emptyUnit } from "./emptyCourseStructures";

interface CourseStructureInfo {
  label: LangKey;
  listLabel: LangKey;
  addLabel: LangKey;
  genFn?: (id: number) => any;
}

export const course_structures = {
  chapters: {
    label: "Course.Chapter",
    listLabel: "Course.Chapters",
    addLabel: "Course.AddChapter",
    genFn: emptyUnit,
  } as CourseStructureInfo,
  lessons: {
    label: "Course.Lesson",
    listLabel: "Course.Lessons",
    addLabel: "Course.AddLesson",
    genFn: emptyLesson,
  } as CourseStructureInfo,
  steps: {
    label: "Course.Step",
    listLabel: "Course.Steps",
    addLabel: "Course.AddStep",
  } as CourseStructureInfo,
  conversations: {
    label: "Course.Conversation",
    listLabel: "Course.Conversations",
    addLabel: "Course.AddConversation",
  } as CourseStructureInfo,
  questions: {
    label: "Course.Question",
    listLabel: "Course.Questions",
    addLabel: "Course.AddQuestion",
  } as CourseStructureInfo,
};
